/**
 * The brand block — `108 × 145` at y = 67 on every auth screen
 * (design-spec.md §1): a 72×72 radius-18 gradient tile holding a 36px "X",
 * then "ثمین اکس" at 26/Bold and the "SAMINEX" wordmark at 11.
 *
 * The tile's radial gradient is centred on its bottom edge — sampled from
 * renders/03-login.png, where the bottom-centre reads #1B62F2 and the top
 * edge #72C8FC, matching the two Figma stops.
 */
export function Brand() {
  return (
    <div className="flex flex-col items-center gap-[18px]">
      <div
        className="flex size-[72px] items-center justify-center rounded-18"
        style={{
          backgroundImage:
            'radial-gradient(circle at 50% 100%, var(--sx-primary-glow) 0%, var(--sx-brand-cyan) 100%)',
        }}
      >
        <span className="sx-tight text-36 font-bold text-ink">X</span>
      </div>
      <div className="flex flex-col items-center gap-[2px]">
        {/* 40px line box, per the design's brand-area stack (40 + 2 + 13 = 55). */}
        <span className="text-26 leading-[40px] font-bold whitespace-nowrap text-ink">
          ثمین اکس
        </span>
        <span className="font-wordmark text-11 leading-[13px] tracking-[0.22em] text-ink-60">
          SAMINEX
        </span>
      </div>
    </div>
  )
}
